import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";

export default function StoreSectionDeleteModal({
  open,
  onClose,
  onConfirm,
  section,
  loading,
}) {
  const title = section?.name || "Sección";

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: "18px",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontSize: 18,
          fontWeight: 700,
          color: "#0f172a",
          pb: 1,
        }}
      >
        Eliminar sección
      </DialogTitle>

      <DialogContent sx={{ pt: "8px !important" }}>
        <Stack spacing={1.2}>
          <Typography
            sx={{
              fontSize: 14,
              fontWeight: 700,
              color: "#0f172a",
              lineHeight: 1.3,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {title}
          </Typography>

          <Typography
            sx={{
              fontSize: 14,
              color: "#475569",
              lineHeight: 1.6,
            }}
          >
            ¿Seguro que deseas eliminar{" "}
            <Box
              component="span"
              sx={{
                fontWeight: 700,
                color: "#0f172a",
              }}
            >
              {title}
            </Box>
            ?
          </Typography>

          <Typography
            sx={{
              fontSize: 13,
              color: "#64748b",
              lineHeight: 1.5,
            }}
          >
            Solo se eliminará si no tiene categorías ni productos asociados.
          </Typography>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.2, pt: 1 }}>
        <Button
          variant="outlined"
          onClick={onClose}
          disabled={loading}
          sx={{
            height: 36,
            px: 1.4,
            borderRadius: "9px",
            textTransform: "none",
            fontWeight: 600,
            fontSize: 12.8,
            color: "#334155",
            bgcolor: "#ffffff",
            borderColor: "rgba(51,65,85,0.18)",
            "&:hover": {
              borderColor: "rgba(51,65,85,0.28)",
              bgcolor: "#f8fafc",
            },
          }}
        >
          Cancelar
        </Button>

        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={loading || !section}
          sx={{
            height: 36,
            px: 1.4,
            borderRadius: "9px",
            textTransform: "none",
            fontWeight: 600,
            fontSize: 12.8,
            bgcolor: "#0f172a",
            boxShadow: "none",
            "&:hover": {
              bgcolor: "#111827",
              boxShadow: "none",
            },
          }}
        >
          {loading ? "Eliminando..." : "Eliminar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}